export default "__VITE_ASSET__5880037f__"